module.exports = __webpack_public_path__ + "static/media/problem.b3106357.svg";